export default __webpack_public_path__ + "be4fc77d991fbe2f0241606b256a4e80.webp";